<template>
    <div>

        <b-form-group :label="label" >
            <vue-tel-input 
                :placeholder="placeholder"
                :valid-characters-only="true"
                :preferred-countries="['UY', 'AR', 'BR']"
                v-model="value.national"
                :default-country="defaultCountry"
                @input="changed"
                @validate="phoneValidated"
                :wrapperClasses="{'is-invalid form-control':hasError}"
                ></vue-tel-input>
            <b-form-invalid-feedback>Ingrese un teléfono válido</b-form-invalid-feedback>
        </b-form-group>

    </div>
</template>

<script>
import { VueTelInput } from 'vue-tel-input'

export default {
    name: "phoneInput",
    components:{
		VueTelInput,
	},
    props:{
        hasError:{
            type: Boolean
        },
        label:{
            type: String
        },
        placeholder:{
            type: String
        },
        defaultCountry:{
            type: String
        },
        value:{
            type: Object,
            default: () => ({number:null, type: null})
        }
    },
    methods:{
        phoneValidated(data) {
			this.value.national 		= data.number.input;
			this.value.international 	= data.number.international;
			this.value.countryCode 	    = data.country.iso2;
			this.value.validated 		= data.isValid;
			this.value.type 			= data.type;
		},
        changed(){
            this.$emit('input',this.value)
            this.$emit('changed')
        }
    }

}
</script>

<style lang="scss">
.vue-tel-input{
    border: 1px solid #ced4da !important;
    height: calc(1.5em + .75rem + 2px);
    padding: .375rem .75rem;
    font-size: .9rem;

    .vti__input:focus{
        border:none;
        box-shadow: none;
        outline: 0;
    
    }
    

    &.is-invalid{
        border-color: #dc3545 !important;
    }
}
</style>